import React from 'react'
import { EllipsisOutlined } from '@ant-design/icons';
import ProjectEdit from './ProjectEdit';
import { Dropdown } from 'antd';
import ProjectDel from './ProjectDel';
import ModuleAdd from '../module/ModuleAdd';

function ProjectDropdown(props) {
    const items = [
        {
            label: (
                <ProjectEdit bg_id={props.bg_id} bg_name={props.bg_name} />
            ),
            key: 'ProjectEdit',
        },
        {
            label: (
                <ProjectDel bg_id={props.bg_id}/>
            ),
            key: 'ProjectDel',
        },       
        {
            type: 'divider',
        },
        {
            label: (
                <ModuleAdd bg_id={props.bg_id} bg_name={props.bg_name}/>
            ),
            key: 'ModuleAdd',
        },       
    ];
    return (
        <Dropdown menu={{ items }} trigger={['click']}>
            <a onClick={e => e.preventDefault()}> <EllipsisOutlined /></a>
        </Dropdown>
    )
}

export default ProjectDropdown